import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputTextSF from "../../../widgets/form/InputTextSF";


const InvoiceItemUpdateModalUI = ({
	context, successMsg, errorList, setErrorList,
	invoiceItemUpdateMode, onSubmit, submitted, onCancelClick,
	productItemId, onProductItemIdChange, productItemIdError, setProductItemIdError,
	quantity, onQuantityChange, quantityError, setQuantityError,

}) =>
	<ModalFormUI
		context={context}
		titleLabel='Update Invoice Item'
		buttonLabel='Update'
		cancelLabel='Cancel'
		isOpen={invoiceItemUpdateMode}
		onRequestClose={onCancelClick}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>

		<div className='col'>
			<InputTextSF type='text' name='productItemId' maxLength={40}
				label='Product Item Id'
				value={productItemId} onChange={onProductItemIdChange}
				error={productItemIdError} setError={setProductItemIdError}
			/>
			<InputTextSF type='text' name='quantity' maxLength={40}
				label='Quantity'
				value={quantity} onChange={onQuantityChange}
				error={quantityError} setError={setQuantityError}
			/>
			{/* <InputTextSF type='text' name='price' required={true} maxLength={40}
                    label='Price'
                    value={price} onChange={onPriceChange}
                    error={priceError} setError={setPriceError}
                />
                <InputTextSF type='text' name='maker' maxLength={250}
                    label='Maker'
                    value={maker} onChange={onMakerChange}
                    error={makerError} setError={setMakerError}
                /> */}
		</div>

	</ModalFormUI>

export default InvoiceItemUpdateModalUI;
